import React, { ChangeEvent, FC } from 'react';
import { formatDecimalNumber } from '../../../../utils/helper';
import {
    Alert,
    Autocomplete,
    CircularProgress,
    Grid,
    MenuItem
} from '@mui/material';
import NewCustomSelect from '../../../newcustomselect/newcustomselect';
import Customdatepicker from '../../../customdatepicker/customdatepicker';
import {
    medthodsOfDispatch,
    typesOfShipment
} from '../../../../utils/appconstants';
import Quotefield from '../../../../pages/dashboard/tradedocuments/quotation/quotefield/quotefield';
import Signature from '../../../signature/signature';
import ChooseDocUpload from '../../../custommodal/ChooseDocUpload';
import UploadLogo from '../common/UploadLogo';
import PortsAutocomplete from '../../../autocompletewithapi/PortsAutocomplete';
import PurchaseOrderMobileForm from './FormsMobileView/PurchaseOrder';
import { Currency } from '../../../../pages/dashboard/payments/interfaces/Currency';
import { TradeDocumentForm } from '../../../../interfaces/TradeDocument';
import CustomTextField from '../../../CustomTextInput';
import {
    PurchaseOrder,
    PurchaseOrderFormErrors
} from '../../../../interfaces/PurchaseOrder';
import { CorporatePartner } from '../../../../interfaces/CorporatePartner';

export interface PurchaseOrderFormProps extends TradeDocumentForm {
    payload: PurchaseOrder;
    errors: PurchaseOrderFormErrors;
    currencies: Currency[];
    loadingCurrencies: boolean;
}

const PurchaseForms: FC<PurchaseOrderFormProps> = ({
    error,
    updateField,
    payload,
    corporatePartners,
    loadingCorporatepartners,
    setShowAddPartner,
    errors,
    quoteFields,
    updateQuoteField,
    removeQuoteField,
    currencies,
    addQuoteField,
    loadingCurrencies,
    setSignatureUrlBase64,
    signatureUrlBase64,
    totalAmount,
    activeStep,
    setActiveStep,
    onSaveOnlyAction,
    showPreview,
    setShowPreview
}): JSX.Element => {
    return (
        <>
            <PurchaseOrderMobileForm
                {...{
                    updateField,
                    payload,
                    corporatePartners,
                    loadingCorporatepartners,
                    setShowAddPartner,
                    errors,
                    quoteFields,
                    updateQuoteField,
                    removeQuoteField,
                    currencies,
                    addQuoteField,
                    loadingCurrencies,
                    setSignatureUrlBase64,
                    signatureUrlBase64,
                    totalAmount,
                    activeStep,
                    setActiveStep,
                    onSaveOnlyAction,
                    showPreview,
                    setShowPreview
                }}
            />
            <div className='hidden lg:block form-container'>
                <div className='border-0 border-appcolorgreyfaint'>
                    {error !== null && (
                        <div className='mb-4'>
                            <Alert severity='error'>{error}</Alert>
                        </div>
                    )}

                    <form>
                        <div className=''>
                            <div className='flex gap-2 items-center'>
                                <UploadLogo {...{ payload, updateField }} />

                                <ChooseDocUpload {...{ updateField, payload }}>
                                    <p>Choose Logo</p>
                                </ChooseDocUpload>
                            </div>

                            <Grid container>
                                <Grid item xs={12} md={12} lg={6}>
                                    <div className='border border-appcolorgreyfaint px-[1rem] pt-[1.1rem] pb-4 h-full'>
                                        <Grid
                                            container
                                            spacing={1}
                                            sx={{
                                                marginTop: 0
                                            }}
                                        >
                                            <Grid item xs={12} md={12} lg={12}>
                                                <NewCustomSelect
                                                    selectValue={
                                                        payload.sellerId as unknown as string
                                                    }
                                                    required
                                                    selectOptions={
                                                        corporatePartners as unknown as (
                                                            | string
                                                            | Record<
                                                                  string,
                                                                  unknown
                                                              >
                                                        )[]
                                                    }
                                                    name={'sellerId'}
                                                    updateField={(_, value) => {
                                                        updateField(
                                                            'sellerId',
                                                            value
                                                        );
                                                        updateField(
                                                            'sellerBank',
                                                            corporatePartners.filter(
                                                                (
                                                                    item: CorporatePartner
                                                                ) =>
                                                                    item.id ===
                                                                    value
                                                            )[0]?.bankName
                                                        );
                                                        updateField(
                                                            'sellerBankAccount',
                                                            corporatePartners.filter(
                                                                (
                                                                    item: CorporatePartner
                                                                ) =>
                                                                    item.id ===
                                                                    value
                                                            )[0]
                                                                ?.bankAccountNumber
                                                        );
                                                        updateField(
                                                            'sellerSwiftCode',
                                                            corporatePartners.filter(
                                                                (
                                                                    item: CorporatePartner
                                                                ) =>
                                                                    item.id ===
                                                                    value
                                                            )[0]?.swiftCode
                                                        );
                                                        updateField(
                                                            'sellerAddress',
                                                            corporatePartners.filter(
                                                                (
                                                                    item: CorporatePartner
                                                                ) =>
                                                                    item.id ===
                                                                    value
                                                            )[0]?.address
                                                        );
                                                        updateField(
                                                            'sellerName',
                                                            corporatePartners.filter(
                                                                (
                                                                    item: CorporatePartner
                                                                ) =>
                                                                    item.id ===
                                                                    value
                                                            )[0]?.name
                                                        );
                                                    }}
                                                    label={'Invoice From'}
                                                    selectOptionLabel='name'
                                                    loading={
                                                        loadingCorporatepartners
                                                    }
                                                    dropdownRender={() => {
                                                        return (
                                                            <div className='px-4 border-t border-appcolorgreyfaint'>
                                                                <p
                                                                    className='px-4 py-2 cursor-pointer text-appcolorprimary'
                                                                    onClick={() => {
                                                                        setShowAddPartner(
                                                                            true
                                                                        );
                                                                    }}
                                                                >
                                                                    + Add a New
                                                                    Partner
                                                                </p>
                                                            </div>
                                                        );
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={12} lg={3}>
                                    <div className='border border-appcolorgreyfaint px-[1rem] pt-[1.1rem] pb-4'>
                                        <CustomTextField
                                            error={
                                                errors?.purchaseOrderNumber
                                                    .length > 0
                                            }
                                            helperText={
                                                errors?.purchaseOrderNumber
                                                    .length > 0
                                                    ? errors?.purchaseOrderNumber
                                                    : undefined
                                            }
                                            required
                                            id='purchaseorder-purchaseOrderNumber'
                                            label='Purchase Order Number'
                                            name='purchaseOrderNumber'
                                            value={payload?.purchaseOrderNumber}
                                            onChange={(
                                                e: ChangeEvent<HTMLInputElement>
                                            ) => {
                                                updateField(
                                                    'purchaseOrderNumber',
                                                    e.target.value
                                                );
                                            }}
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={12} lg={3}>
                                    <div className='border border-appcolorgreyfaint px-[1rem] pt-[1.1rem] pb-4 h-full'>
                                        <Customdatepicker
                                            value={
                                                payload?.documentDate || null
                                            }
                                            id='quotation-issuedDate'
                                            label='Date'
                                            name='issuedDate'
                                            updateField={updateField}
                                            error={
                                                errors?.documentDate.length > 0
                                            }
                                            helperText={
                                                errors?.documentDate.length > 0
                                                    ? errors?.documentDate
                                                    : undefined
                                            }
                                        />
                                    </div>
                                </Grid>
                            </Grid>

                            <Grid container>
                                <Grid item xs={12} md={12} lg={6}>
                                    <div className='border border-appcolorgreyfaint px-[1rem] pt-[1.1rem] pb-4 h-full'>
                                        <NewCustomSelect
                                            selectValue={
                                                payload.receiverId as unknown as string
                                            }
                                            required
                                            selectOptions={
                                                corporatePartners as unknown as (
                                                    | string
                                                    | Record<string, unknown>
                                                )[]
                                            }
                                            name={'receiverId'}
                                            updateField={(_, value) => {
                                                updateField(
                                                    'receiverId',
                                                    value
                                                );
                                                updateField(
                                                    'receiverAddress',
                                                    corporatePartners.filter(
                                                        (
                                                            item: CorporatePartner
                                                        ) => item.id === value
                                                    )[0]?.address
                                                );
                                                updateField(
                                                    'receiverBank',
                                                    corporatePartners.filter(
                                                        (
                                                            item: CorporatePartner
                                                        ) => item.id === value
                                                    )[0]?.bankName
                                                );
                                                updateField(
                                                    'receiverBankAccount',
                                                    corporatePartners.filter(
                                                        (
                                                            item: CorporatePartner
                                                        ) => item.id === value
                                                    )[0]?.bankAccountNumber
                                                );
                                                updateField(
                                                    'receiverSwiftCode',
                                                    corporatePartners.filter(
                                                        (
                                                            item: CorporatePartner
                                                        ) => item.id === value
                                                    )[0]?.swiftCode
                                                );
                                                updateField(
                                                    'receiverName',
                                                    corporatePartners.filter(
                                                        (
                                                            item: CorporatePartner
                                                        ) => item.id === value
                                                    )[0]?.name
                                                );
                                            }}
                                            label={'Invoice  To'}
                                            selectOptionLabel='name'
                                            loading={loadingCorporatepartners}
                                            dropdownRender={() => {
                                                return (
                                                    <div className='px-4 border-t border-appcolorgreyfaint'>
                                                        <p
                                                            className='px-4 py-2 cursor-pointer text-appcolorprimary'
                                                            onClick={() => {
                                                                setShowAddPartner(
                                                                    true
                                                                );
                                                            }}
                                                        >
                                                            + Add a New Partner
                                                        </p>
                                                    </div>
                                                );
                                            }}
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={12} lg={6}>
                                    <div className='border border-appcolorgreyfaint px-[1rem] pt-[1.1rem] pb-4'>
                                        <Grid
                                            container
                                            spacing={1}
                                            sx={{
                                                marginTop: 0
                                            }}
                                        >
                                            <Grid item xs={12} md={12} lg={6}>
                                                <CustomTextField
                                                    error={
                                                        errors
                                                            ?.supplierReference
                                                            .length > 0
                                                    }
                                                    helperText={
                                                        errors
                                                            ?.supplierReference
                                                            .length > 0
                                                            ? errors?.supplierReference
                                                            : undefined
                                                    }
                                                    required
                                                    id='purchaseorder-supplierReference'
                                                    label='Supplier Reference'
                                                    name='supplierReference'
                                                    value={
                                                        payload?.supplierReference
                                                    }
                                                    onChange={(
                                                        e: ChangeEvent<HTMLInputElement>
                                                    ) => {
                                                        updateField(
                                                            'supplierReference',
                                                            e.target.value
                                                        );
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={12} lg={6}>
                                                <CustomTextField
                                                    error={
                                                        errors?.shipperReference
                                                            .length > 0
                                                    }
                                                    helperText={
                                                        errors?.shipperReference
                                                            .length > 0
                                                            ? errors?.shipperReference
                                                            : undefined
                                                    }
                                                    required
                                                    value={
                                                        payload?.shipperReference
                                                    }
                                                    id='purchaseorder-shipperReference'
                                                    label='Shipper Reference'
                                                    name='shipperReference'
                                                    onChange={(
                                                        e: ChangeEvent<HTMLInputElement>
                                                    ) => {
                                                        updateField(
                                                            'shipperReference',
                                                            e.target.value
                                                        );
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>

                            <Grid container>
                                <Grid item xs={12} md={12} lg={6}>
                                    <div className='border border-appcolorgreyfaint px-[1rem] pt-[1.1rem] pb-4'>
                                        <Grid
                                            container
                                            spacing={1}
                                            sx={{
                                                marginTop: '0px'
                                            }}
                                        >
                                            <Grid item xs={12} md={12} lg={6}>
                                                <CustomTextField
                                                    select
                                                    error={
                                                        errors?.methodOfDispatch
                                                            .length > 0
                                                    }
                                                    helperText={
                                                        errors?.methodOfDispatch
                                                            .length > 0
                                                            ? errors?.methodOfDispatch
                                                            : undefined
                                                    }
                                                    required
                                                    id='purchaseorder-methodOfDispatch'
                                                    label='Method of Dispatch'
                                                    name='methodOfDispatch'
                                                    value={
                                                        payload?.methodOfDispatch
                                                    }
                                                    onChange={(
                                                        e: ChangeEvent<HTMLInputElement>
                                                    ) => {
                                                        updateField(
                                                            'methodOfDispatch',
                                                            e.target.value
                                                        );
                                                    }}
                                                >
                                                    {medthodsOfDispatch.map(
                                                        (item, index) => (
                                                            <MenuItem
                                                                value={item}
                                                                key={`medthodsOfDispatch-${item}-${index}`}
                                                            >
                                                                {item}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </CustomTextField>
                                            </Grid>

                                            <Grid item xs={12} md={12} lg={6}>
                                                <CustomTextField
                                                    select
                                                    error={
                                                        errors?.typeOfShipment
                                                            .length > 0
                                                    }
                                                    helperText={
                                                        errors?.typeOfShipment
                                                            .length > 0
                                                            ? errors?.typeOfShipment
                                                            : undefined
                                                    }
                                                    required
                                                    id='purchaseorder-typeOfShipment'
                                                    label='Type of Shipment'
                                                    name='typeOfShipment'
                                                    value={
                                                        payload?.typeOfShipment
                                                    }
                                                    onChange={(
                                                        e: ChangeEvent<HTMLInputElement>
                                                    ) => {
                                                        updateField(
                                                            'typeOfShipment',
                                                            e.target.value
                                                        );
                                                    }}
                                                >
                                                    {typesOfShipment.map(
                                                        (item, index) => (
                                                            <MenuItem
                                                                value={item}
                                                                key={`typesOfShipment-${item}-${index}`}
                                                            >
                                                                {item}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </CustomTextField>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </Grid>

                                <Grid item xs={12} md={12} lg={6}>
                                    <div className='border border-appcolorgreyfaint px-[1rem] pt-[1.1rem] pb-4'>
                                        <Grid
                                            container
                                            spacing={1}
                                            sx={{
                                                marginTop: '0px'
                                            }}
                                        >
                                            <Grid item xs={12} md={12} lg={6}>
                                                <PortsAutocomplete
                                                    errorCondition={
                                                        errors?.portOfLoadingId
                                                            .length > 0
                                                    }
                                                    helperText={
                                                        errors?.portOfLoadingId
                                                            .length > 0
                                                            ? errors?.portOfLoadingId
                                                            : undefined
                                                    }
                                                    id='quotation-portOfLoading'
                                                    label='Port of Loading'
                                                    name='portOfLoadingId'
                                                    updateField={updateField}
                                                    nameValue='portOfLoadingValue'
                                                    value={
                                                        payload.portOfLoadingValue
                                                    }
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={12} lg={6}>
                                                <PortsAutocomplete
                                                    errorCondition={
                                                        errors
                                                            ?.portOfDischargeId
                                                            .length > 0
                                                    }
                                                    helperText={
                                                        errors
                                                            ?.portOfDischargeId
                                                            .length > 0
                                                            ? errors?.portOfDischargeId
                                                            : undefined
                                                    }
                                                    id='quotation-portOfDischargeId'
                                                    label='Port of Discharge'
                                                    name='portOfDischargeId'
                                                    updateField={updateField}
                                                    nameValue='portOfDischargeValue'
                                                    value={
                                                        payload.portOfDischargeValue
                                                    }
                                                />
                                            </Grid>
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>
                        </div>

                        <div className='border border-appcolorgreyfaint px-[1rem] pt-[1.1rem] pb-4'>
                            <Grid
                                container
                                spacing={1}
                                sx={{
                                    marginTop: '0px'
                                }}
                            >
                                <Grid item xs={12} md={12} lg={6}>
                                    <CustomTextField
                                        error={
                                            errors?.billOfLadingNumber.length >
                                            0
                                        }
                                        helperText={
                                            errors?.billOfLadingNumber?.length >
                                            0
                                                ? errors?.billOfLadingNumber
                                                : undefined
                                        }
                                        value={payload?.billOfLadingNumber}
                                        required
                                        id='quotation-billOfLadingNumber'
                                        label='Bill of Lading Number'
                                        name='billOfLadingNumber'
                                        onChange={(
                                            e: ChangeEvent<HTMLInputElement>
                                        ) => {
                                            updateField(
                                                'billOfLadingNumber',
                                                e.target.value
                                            );
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={12} lg={6}>
                                    <CustomTextField
                                        error={
                                            errors?.salesContractNumber
                                                ?.length > 0
                                        }
                                        helperText={
                                            errors?.salesContractNumber
                                                ?.length > 0
                                                ? errors?.salesContractNumber
                                                : undefined
                                        }
                                        value={payload?.salesContractNumber}
                                        required
                                        id='quotation-salesContractNumber'
                                        label='Sales Contract Number'
                                        name='salesContractNumber'
                                        onChange={(
                                            e: ChangeEvent<HTMLInputElement>
                                        ) => {
                                            updateField(
                                                'salesContractNumber',
                                                e.target.value
                                            );
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </div>

                        {quoteFields.map((item, index) => (
                            <Quotefield
                                item={item}
                                key={item.id}
                                index={index}
                                id={item.id ?? ''}
                                updateQuoteField={updateQuoteField}
                                price={item.price ?? 0}
                                qty={item.qty ?? 0}
                                removeQuoteField={removeQuoteField}
                            />
                        ))}

                        <div className=''>
                            <div className='border border-appcolorgreyfaint px-[1rem] pt-8 pb-8'>
                                <div
                                    className='flex items-center cursor-pointer w-fit'
                                    onClick={() => {
                                        addQuoteField();
                                    }}
                                >
                                    <div>
                                        <img
                                            src='/img/vectors/primarydownload.svg'
                                            alt='primarydownload'
                                            className='w-6'
                                        />
                                    </div>
                                    <span className='pl-2 text-appcolorprimary'>
                                        Add Field
                                    </span>
                                </div>
                            </div>

                            <div className='border border-appcolorgreyfaint px-[1rem] pt-[1.1rem] pb-4 flex justify-end gap-2'>
                                <div className='w-[20%]'>
                                    <Autocomplete
                                        value={
                                            payload.currencyCodeValue as unknown as Currency
                                        }
                                        placeholder='Currency'
                                        disableClearable
                                        id='send-currency'
                                        renderInput={(params) => (
                                            <CustomTextField
                                                params={params}
                                                value={
                                                    payload.currencyCodeValue
                                                }
                                                label='Select Currency'
                                                placeholder='Currency'
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment:
                                                        loadingCurrencies && (
                                                            <React.Fragment>
                                                                <CircularProgress
                                                                    size={20}
                                                                />
                                                                {
                                                                    params
                                                                        .InputProps
                                                                        .endAdornment
                                                                }
                                                            </React.Fragment>
                                                        )
                                                }}
                                            />
                                        )}
                                        noOptionsText={'No data available'}
                                        renderOption={(props, option) => (
                                            <MenuItem
                                                {...props}
                                                value={option.name}
                                                key={`countries-${option.id}`}
                                            >
                                                {option.name}
                                            </MenuItem>
                                        )}
                                        getOptionLabel={(option) => option.name}
                                        onChange={(_, value: Currency) => {
                                            if (value !== null) {
                                                updateField(
                                                    'currencyCode',
                                                    value.currencyCode
                                                );
                                                updateField(
                                                    'currencyCodeValue',
                                                    value as unknown as string
                                                );
                                            }
                                        }}
                                        options={currencies}
                                    />
                                </div>
                                <div className='w-[20%]'>
                                    <CustomTextField
                                        disabled
                                        id='purchaseorder-totalAmount'
                                        label='Total Amount'
                                        name='totalAmount'
                                        value={formatDecimalNumber(totalAmount)}
                                    />
                                </div>
                            </div>

                            <Grid container>
                                <Grid item xs={12} md={12} lg={6}>
                                    <div className='border border-appcolorgreyfaint px-[1rem] pt-[1.1rem] pb-4 h-full'>
                                        <CustomTextField
                                            multiline
                                            rows={7.3}
                                            id='purchaseorder-additionalInformation'
                                            label='Additional Information'
                                            name='additionalInformation'
                                            onChange={(
                                                e: ChangeEvent<HTMLInputElement>
                                            ) => {
                                                updateField(
                                                    'additionalInformation',
                                                    e.target.value
                                                );
                                            }}
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={12} lg={6}>
                                    <div className='border border-appcolorgreyfaint px-[1rem] pt-[1.1rem] pb-4 h-full'>
                                        <Grid
                                            container
                                            spacing={1}
                                            sx={{
                                                marginTop: '0px'
                                            }}
                                        >
                                            <Grid item xs={12} md={12} lg={6}>
                                                <CustomTextField
                                                    error={
                                                        errors?.placeOfIssue
                                                            .length > 0
                                                    }
                                                    helperText={
                                                        errors?.placeOfIssue
                                                            .length > 0
                                                            ? errors?.placeOfIssue
                                                            : undefined
                                                    }
                                                    required
                                                    id='quotation-placeOfIssue'
                                                    label='Place of Issue'
                                                    name='placeOfIssue'
                                                    value={
                                                        payload?.placeOfIssue
                                                    }
                                                    onChange={(
                                                        e: ChangeEvent<HTMLInputElement>
                                                    ) => {
                                                        updateField(
                                                            'placeOfIssue',
                                                            e.target.value
                                                        );
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={12} lg={6}>
                                                <Customdatepicker
                                                    id='purchaseorder-issuedDate'
                                                    label='Date of Issue'
                                                    name='issuedDate'
                                                    updateField={updateField}
                                                    error={
                                                        errors?.issuedDate
                                                            .length > 0
                                                    }
                                                    helperText={
                                                        errors?.issuedDate
                                                            .length > 0
                                                            ? errors?.issuedDate
                                                            : undefined
                                                    }
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={12} lg={12}>
                                                <div className='my-4'>
                                                    <CustomTextField
                                                        error={
                                                            errors
                                                                ?.signatoryCompany
                                                                .length > 0
                                                        }
                                                        helperText={
                                                            errors
                                                                ?.signatoryCompany
                                                                .length > 0
                                                                ? errors?.signatoryCompany
                                                                : undefined
                                                        }
                                                        required
                                                        id='proformainvoice-signatoryCompany'
                                                        label='Signatory Company'
                                                        name='signatoryCompany'
                                                        value={
                                                            payload?.signatoryCompany
                                                        }
                                                        onChange={(
                                                            e: ChangeEvent<HTMLInputElement>
                                                        ) => {
                                                            updateField(
                                                                'signatoryCompany',
                                                                e.target.value
                                                            );
                                                        }}
                                                    />
                                                </div>
                                            </Grid>
                                            <Grid item xs={12} md={12} lg={12}>
                                                <CustomTextField
                                                    error={
                                                        errors
                                                            ?.nameOfAuthorisedSignatory
                                                            .length > 0
                                                    }
                                                    helperText={
                                                        errors
                                                            ?.nameOfAuthorisedSignatory
                                                            .length > 0
                                                            ? errors?.nameOfAuthorisedSignatory
                                                            : undefined
                                                    }
                                                    required
                                                    id='proformainvoice-nameOfAuthorisedSignatory'
                                                    label='Name of Authorized Signature'
                                                    name='nameOfAuthorisedSignatory'
                                                    value={
                                                        payload?.nameOfAuthorisedSignatory
                                                    }
                                                    onChange={(
                                                        e: ChangeEvent<HTMLInputElement>
                                                    ) => {
                                                        updateField(
                                                            'nameOfAuthorisedSignatory',
                                                            e.target.value
                                                        );
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={12} lg={12}>
                                                <div className='w-full pt-2'>
                                                    <Signature
                                                        name='signatureUrl'
                                                        updateField={
                                                            updateField
                                                        }
                                                        setSignatureUrlBase64={
                                                            setSignatureUrlBase64
                                                        }
                                                        signatureUrlBase64={
                                                            signatureUrlBase64
                                                        }
                                                    />
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default PurchaseForms;
